export default {
  // 企業情報
  PAGE_TITLE: "企業情報",
  COMPANY_INFO: "企業情報",
};
